import { render } from "./CounterpartiesItem.vue?vue&type=template&id=345b26dc"
import script from "./CounterpartiesItem.vue?vue&type=script&lang=js"
export * from "./CounterpartiesItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__